<template>
  <div style="margin-right: 1em;">
    <div class="form-row">
      <div class="form-group col-6">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $t('resource.format.label') }}
        </label>
        <p class="label-help">
          {{ $t('resource.format.help') }}
        </p>
        <ValidatedFileFormatSelector
          :required="resource.isNotEmpty()"
          validation-name="Format FileDownload"
          @select="selectFormat($event)"
        />
        <p style="margin-top: 0.5em; font-size: 0.85em; white-space: wrap;">
          {{ $t('resource.fileUpload.formatHelp') }}
        </p>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          URL
        </label>
        <p>{{ $t('resource.fileDownload.help') }}</p>
        <ValidationProvider
          v-slot="{ classes, errors }"
          name="URL"
          :rules="`${resource.isNotEmpty() ? 'required' : ''}`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.filedownload.href"
              v-sanitize
              class="form-control"
              type="text"
              placeholder="https://"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';

import { mapState, mapActions } from 'vuex';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'FileDownloadCreator',

  components: {
    ValidatedFileFormatSelector,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => {}
    },
    isMain: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      form: {
        type: 'file-download',
        format: null,
      }
    };
  },

  computed: {
    ...mapState('resources', [
      'schedulers'
    ])
  },

  watch: {
    'form.format': function() {
      this.setResourceURL();
    },
  },

  created() {
    this.resource.type = 'file-download';
    this.$set(this.resource, 'filedownload', {});
  },

  methods: {
    ...mapActions('resources', [
      'GET_SCHEDULERS'
    ]),
    selectFormat(format) {
      this.form.format = format;
      this.$set(this.resource.filedownload, 'dataformat', format.codename);
    },
  
  }  
};
</script>
